module.exports = __webpack_public_path__ + "733f9cebdd254c4928201e50ba92664b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-dark-s.png
// module id = 2680
// module chunks = 0